/**
 * Product Card Swiper Global Initialization
 */

document.addEventListener('DOMContentLoaded', function() {
  initializeProductCardSwipers();
});

function initializeProductCardSwipers() {
  const swipers = document.querySelectorAll('.product-card-swiper');
  
  swipers.forEach(function(swiperElement) {
    // Skip if already initialized
    if (swiperElement.swiper) return;
    
    // Only initialize if there are multiple slides
    const slides = swiperElement.querySelectorAll('.swiper-slide');
    if (slides.length <= 1) return;
    
    new Swiper(swiperElement, {
      simulateTouch: false,
      spaceBetween: 4,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      lazy: {
        loadPrevNext: true,
      },
      on: {
        init: function() {
          // Swiper initialized
        }
      }
    });
  });
}

// Re-initialize when new content is loaded (for AJAX/dynamic content)
document.addEventListener('shopify:section:load', function() {
  initializeProductCardSwipers();
}); 